import React, { useState } from 'react'
import { Navbar, ListGroup } from 'react-bootstrap'
import { withRouter, Link } from 'react-router-dom'
import { FiSearch, FiX } from 'react-icons/fi'
import surah from '../db/surah.json'

function HeaderComponent(props) {
  const [isSearch, setIsSearch] = useState(false)
  const [searchResult, setSearchResult] = useState([])
  const showSearch = () => {
    isSearch ? setIsSearch(false) : setIsSearch(true)
    setSearchResult([])
  }
  const onSearch = (e) => {
    if (e.target.value === '') {
      setSearchResult([])
    } else {
      const res = surah.filter(s => s.surat_name.toLowerCase().replace(`'`, '').indexOf(e.target.value) > -1)
      setSearchResult(res.slice(0,5))
    }
  }
  const onResultClick = (path) => {
    showSearch()
    props.history.push(path)
  }
  return (
    <>
      {
        isSearch ?
          (
            <div className="myHeadSearch">
              <Navbar >
                <input onChange={onSearch} className="mySearchInput" type="text" placeholder="Ketik Nama Surat..." autoFocus />
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end">
                  <FiX onClick={showSearch} className="mySearchButton" />
                </Navbar.Collapse>
              </Navbar>
              <ListGroup variant="flush">
                {
                  searchResult.map(res => (
                    <ListGroup.Item className="resultSearch" key={res.id} onClick={() => onResultClick(res.surat_name.toLowerCase().replace(' ', '-').replace(`'`, ''))}>{res.surat_name}</ListGroup.Item>
                    )
                  )
                }
              </ListGroup>
            </div>
          ) : (
            <Navbar bg="light" className="myHead" sticky="top">
              <Link to="/">
                <Navbar.Brand>DigiQuran</Navbar.Brand>
              </Link>
              <Navbar.Toggle />
              <Navbar.Collapse className="justify-content-end">
                <FiSearch onClick={showSearch} className="mySearchButton" />
              </Navbar.Collapse>
            </Navbar >
          )
      }
    </>
  )
}

export default withRouter(HeaderComponent)